import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@shared/assets/styles/index.css'
import '@features/dashboard/styles/erp-dashboard.css'
import App from './App.tsx'

import { initSentry } from '@shared/configs/sentry'

initSentry()

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App />
    </StrictMode>
)

requestAnimationFrame(() => {
    requestAnimationFrame(() => {
        const loader = document.getElementById('initial-loader')
        if (!loader) return
        loader.classList.add('is-fading')
        loader.setAttribute('aria-hidden', 'true')
        setTimeout(() => loader.remove(), 600)
    })
})
